import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { UserService } from 'app/services/user.service';

@Component({
  selector: 'app-authorize',
  templateUrl: './authorize.component.html',
  styleUrls: ['./authorize.component.scss']
})
export class AuthorizeComponent implements OnInit {

  constructor(private route: ActivatedRoute, private userService: UserService) {
    this.route.queryParams.subscribe(params => {
      this.userService.getCurrent().subscribe(() => {
        location.href = this.userService.getAuthorizeUrl(params['client_id'], params['redirect_uri'], params['scope'],
        params['response_type'], params['state']);
      }, () => {
        this.userService.logout();
      })
    });
   }

  ngOnInit() {
  }

}
